import { enUS, es } from "date-fns/locale";

export function getLocale(language?: string) {
    if (!language) return enUS;
    if (language.startsWith("es")) return es;
    return enUS;
}
